import React, { useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import SdwSelect from '@common/Select'
import SdwTable from '@common/Table'
import SdwButton from '@common/Button'
import SdwEnable from '@common/Enable'
import SdwPagenation from '@common/Pagenation'
import EditWin from './EditWin'
import { getItemsSelect, queryFormsConfPage } from '@services/operationConfiguration'
import '../style/BusinessIndicatorsOperation.css'
import SdwMessage from '@common/Message/index'
import { hasPriv } from '@components/FrontendAuth/AuthMap'
import SdwInput from '@common/Input'

// 1：归档项，2：产品，3：l4
const TYPE_MAP = {
  no_config_task: 1,
  aio_server: 2,
  ai_code: 3
}

export default function FormConfig(props) {

  const [timer, setTimer] = useState(null)
  const [showEditWin, setShowEditWin] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [params, setParams] = useState({
    page: 1,
    limit: 10
  })
  const [curItem, setCurItem] = useState({})
  const [tableData, setTableData] = useState({})
  const [formTypeData, setFormTypeData] = useState([])
  //const [searchParams, setSearchParams] = useState({"create_user":"", "form_id":"", "form_type":""})

  useEffect(onQueryFormsConfPage, [])

  useEffect(() => {
    onQueryFormsConfPage(params)
  }, [params])

  useEffect(() => {
    getItemsSelect({}).then(res => {
      let code = _.get(res, 'data.code')
      if (code === 0) {
        let ret = _.get(res, 'data.data')
        let data = ret.form_business
        data = _.isArray(data) ? data : []
        formatSelectOptions(data)
      }
    })
  }, [])

  function onQueryFormsConfPage(params = {}) {
    if (!_.isEmpty(params)) {
      params = {
        ...params.page ? {
          page: params.page
        } : {},
        ...params.limit ? {
          limit: params.limit
        } : {},
        search: JSON.stringify({
          ...params.form_id ? {
            form_id: {
              value: params.form_id,
              operator: '='
            }
          } : {},
          ...params.create_user ? {
            create_user: {
              value: params.create_user,
              operator: '='
            }
          } : {},
          ...params.hasOwnProperty("form_type") && params.form_type !== "" ? {
            form_type: {
              value: params.form_type,
              operator: '='
            }
          } : {}
        })
      }
    }
    console.log("=========", params)
    queryFormsConfPage(params).then(res => {
      const code = _.get(res, 'data.code')
      const msg = _.get(res, 'data.msg')
      if (code === 0) {
        const jasonData = _.get(res, 'data.data')
        setTableData(jasonData)
      } else {
        SdwMessage.error('接口请求异常: ' + msg)
      }
    })
  }

  function getColumns() {
    return [
      {
        title: "ID",
        width: 80,
        dataIndex: "id"
      }, {
        title: "表单ID",
        width: 160,
        dataIndex: "form_id"
      }, {
        title: "表单类型",
        width: 80,
        render:function(data) {
          if (data.form_type === null || data.form_type === "") {
            return "无业务类型"
          } else {
            return formTypeData.map(i => {
              if (i.id === data.form_type) {
                return i.text
              }
            })
          }
        }
      }, {
        title: "配置人",
        width: 80,
        dataIndex: "create_user"
      }, {
        title: "创建时间",
        width: 100,
        dataIndex: "create_time"
      }, {
        title: "修改人",
        width: 80,
        dataIndex: "update_user"
      }, {
        title: "创建时间",
        width: 100,
        dataIndex: "update_time"
      },
      {
        title: "操作",
        width: 80,
        render: data => (
          <>
            <SdwButton
              text="编辑"
              onClick={() => {
                setShowEditWin(true)
                setIsEdit(true)
                setCurItem(data)
              }}
            />
          </>
        )
      }
    ]
  }

  function updateParams(type, val) {
    console.log("====", params)
    console.log("====", type, '===', val)
    let cloneParams = _.cloneDeep(params)
    cloneParams[type] = val
    if (type != 'page') {
      cloneParams['page'] = 1
    }
    setParams(cloneParams)
  }

  function onUpdatePage() {
    onQueryFormsConfPage(params)
  }

  function onSearch(type, val) {
    onQueryFormsConfPage(params)
  }

  function formatSelectOptions(data) {
    data.unshift({
        value:"",
        name:"全部"
    })
    const list = _.isArray(data) ? data.map(i => {
      return {
        id: i.value.toString(),
        text: i.name
      }
    }) : []

    setFormTypeData(list)
  }

  function handleOnFocus(type, val) {
    if (!val) onSearch(type, '')
  }

  return (
    <div>
      <div className="page-mainbody">
        <div className="sdw-business-indicators__wrap">

          <span className="sdw-business-indicators-search__wrap">
            <SdwInput
                width={250}
                label="表单ID"
                placeholder={"请输入"}
                value={params.form_id}
                onBlur={val=>updateParams('form_id', val)}
                onEnterKeyDown={() => ({})} // enter或触发onblur事件，所以这里传空func
                onChange={val => updateParams('form_id', val)}
            />
          </span>

          <span className="sdw-business-indicators-search__wrap">
            <SdwSelect
                placeholder="请选择"
                width={250}
                label="表单类型"
                readOnly={false}
                value={params.form_type}
                data={formTypeData}
                // onInputFilter={val => onSearch('form_type', val)}
                // onFocus={val => handleOnFocus(TYPE_MAP.service_id, val)} // 首次点击下拉框，触发搜索接口
                onChange={val => updateParams('form_type', val)}
            />
          </span>

          <span className="sdw-business-indicators-search__wrap">
            <SdwInput
                width={250}
                label="配置人"
                placeholder={"请输入"}
                value={params.create_user}
                onBlur={val=>updateParams('create_user', val)}
                onEnterKeyDown={() => ({})} // enter或触发onblur事件，所以这里传空func
                onChange={val => updateParams('create_user', val)}
            />
          </span>

          <span className="sdw-business-indicators-search__wrap btn-group">
            {
              hasPriv('insertArchiveCodeConf') &&
              <button
                className="sure-button el-icon-plus"
                icon="plus"
                onClick={() => {
                  setShowEditWin(true)
                  setIsEdit(false)
                  setCurItem({})
                }}
              >添加配置</button>
            }
          </span>
        </div>

        <SdwTable
          columns={ getColumns() }
          dataSource={ _.isArray(tableData.items) ? tableData.items : [] }
        />

        <div style={{ marginTop: '16px' }}>
          <SdwPagenation
            total={ tableData.total }
            currentPage={ tableData.current_page }
            pageCountList={[10, 15, 20, 40]}
            pageCount={ tableData.per_page }
            getClickPage={ page => updateParams('page', page) }
            pageCountChange={ limit => updateParams('limit', limit) }
          />
        </div>
      </div>

      {
        showEditWin &&
        <EditWin
          isEdit={isEdit}
          data={curItem}
          showEditWin={showEditWin}
          setShowEditWin={bool => setShowEditWin(bool)}
          updatePage={onUpdatePage}
        />
      }

    </div>
  )
}
